import React, { useState, useEffect } from "react";

interface NotesSectionProps {
  selectedDay: string;
  initialNote?: string;
  onNoteChange: (date: string, note: string) => void;
}

export const NotesSection: React.FC<NotesSectionProps> = ({
  selectedDay,
  initialNote = "",
  onNoteChange,
}) => {
  const [localNote, setLocalNote] = useState(initialNote);

  // Update local note when selected day changes
  useEffect(() => {
    setLocalNote(initialNote);
  }, [initialNote, selectedDay]);

  // Debounced save of notes
  useEffect(() => {
    if (localNote === initialNote) return;

    const timeout = setTimeout(() => {
      onNoteChange(selectedDay, localNote);
    }, 300);

    return () => clearTimeout(timeout);
  }, [localNote, selectedDay, initialNote, onNoteChange]);

  const handleNoteChange = (note: string) => {
    setLocalNote(note);
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <h3
        style={{
          margin: "0 0 12px 0",
          fontSize: "1.1em",
          color: "#212529",
        }}
      >
        Daily Notes
      </h3>
      <textarea
        value={localNote}
        onChange={(e) => {
          const note = e.target.value.slice(0, 1000);
          handleNoteChange(note);
        }}
        placeholder="Add your notes for today..."
        style={{
          width: "100%",
          minHeight: "150px",
          padding: "12px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          backgroundColor: "#fff",
          color: "#000",
          fontSize: "14px",
          resize: "vertical",
          outline: "none",
          fontFamily: "inherit",
        }}
      />
      <div
        style={{
          textAlign: "right",
          fontSize: "0.8em",
          color: "#666",
          marginTop: "4px",
        }}
      >
        {localNote.length}/1000
      </div>
    </div>
  );
};
